<template>
    <div class="admin-users-list">
        <!-- HeadFul Plugin For Set Title and Meta Tags Dynamically -->
        <vue-headful
            :title="'User Settings - ' + appName"
        />
        <!-- Set HeadFul End -->
        <!-- Add article permission set -->
        <div class="clearfix border mb-5 pr-5 pl-5">
          <div class="float-left">
            <p class="m-0 mt-5 font-weight-bold">Add article permission for only contributor and admin</p>
          </div>
          <div class="float-right">
            <v-switch v-model="switch1" inset :label="`Contributor Permission ${switch1 ? 'On' : 'Off'}`" :loading="switchLoading"></v-switch>
          </div>
        </div>
        <!-- Search input -->
        <v-text-field
          class="mt-2"
          v-model="search"
          append-icon="mdi-magnify"
          label="Search"
          solo
        ></v-text-field>
        <!-- Data table start -->
        <v-data-table
            :headers="headers"
            :items="desserts"
            :search="search"
            class="elevation-1"
            :class="$vuetify.theme.dark ? 'table-dark' : ''"
            :loading="dataLoading" 
            loading-text="Loading... Please wait"
        >
          <!-- User avatar -->
          <template v-slot:item.avatar="{ item }">
            <router-link :to="{ name: 'Profile', params: { username: item.username } }">
              <v-avatar class="m-2">
                <v-row align="center" justify="center">
                  <!-- Image -->
                  <v-img
                    :src="item.avatar"
                    :lazy-src="item.avatar"
                    aspect-ratio="1"
                    class="grey lighten-2"
                    max-width="50"
                    max-height="50"
                  >
                    <!-- Loading -->
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-row>
              </v-avatar>
            </router-link>
          </template>
          <!-- user profile link -->
          <template v-slot:item.userId="{ item }">
            <router-link :to="{ name: 'Profile', params: { username: item.username } }">
                {{ item.userId }} 
            </router-link>
          </template>
            <!-- table header -->
            <template v-slot:top>
            <v-toolbar flat>
                <v-toolbar-title>All contributing requests</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-spacer></v-spacer>
                <!-- add user button -->
                <v-btn
                  :color="$vuetify.theme.dark ? 'grey darken-3' : 'primary'"
                  dark
                  class="mb-2"
                  :to="{ name: 'Contribute' }"
                >
                  Add One
                </v-btn>
            </v-toolbar>
            </template>
            <!-- edit user button -->
            <template v-slot:item.actions="{ item }">
              <v-btn small :color="$vuetify.theme.dark ? 'grey darken-3' : 'primary'" class="mt-2" @click="sendEmail(item.email)"><v-icon>mdi-email</v-icon></v-btn>
              <v-btn small :color="$vuetify.theme.dark ? 'grey darken-3' : 'primary'" class="mt-2 mb-2" @click="approveRequest(item)"><v-icon>mdi-check</v-icon></v-btn>
              <v-btn small :color="$vuetify.theme.dark ? 'grey darken-3' : 'error'" class="mb-2" @click="dialog = true, selectRequest(item)"><v-icon>mdi-close</v-icon></v-btn>
            </template>
        </v-data-table>
        <!-- Data table end -->
        <!-- dialog for delete -->
        <v-dialog v-model="dialog" persistent max-width="290">
            <v-card>
                <v-card-title class="headline">Are you sure to delete the request?</v-card-title>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :color="$vuetify.theme.dark ? 'white darken-3' : 'error darken-1'" text @click="dialog = false">Disagree</v-btn>
                <v-btn :color="$vuetify.theme.dark ? 'white darken-3' : 'green darken-1'" text @click="requestDecline()">Agree</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
// import firebase app
import firebase from 'firebase/app'
// import firebase auth
import 'firebase/auth'
// import firebase storage
import 'firebase/storage'
// import firebase database
import db from '@/firebase/init'
// moment for convert date
import moment from 'moment/src/moment'

export default {
    name: 'AdminUsers',
    data() {
        return {
            dialog: false,
            dataLoading: false, // vuetify data table loading
            appName: '', // set aplication name
            search: '', // vuetify data table search
            // vuetify data table headers
            headers: [
                { text: 'Serial', value: 'serial', sortable: false },
                { text: 'Avatar', width: "10%", value: 'avatar', sortable: false },
                {
                  text: 'Name',
                  sortable: false,
                  value: 'userId',
                  width: "20%"
                },
                { text: 'Message', width: "50%", value: 'text', sortable: false },
                { text: 'Date', width: "20%", value: 'date' },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            desserts: [], // vuetify data table data
            editedIndex: -1, // vuetify data table editedIndex
            switchLoading: false,
            switch1: true
        }
    },
    watch: {
      // add article permission set
      switch1(val) {
        this.switchLoading = true
        db.collection('settings').doc('add-article-permission').update({ permission: val }).then(() => {
          this.switchLoading = false
        })
      }
    },
    computed: {
      // set error message
      errorMessages() {
        return this.errorMessage ? this.errorMessage : undefined
      }
    },
    created () {
        // add and check article permission
        db.collection('settings').doc('add-article-permission')
        .onSnapshot(doc => {
            if(doc.exists) {
              this.switch1 = doc.data().permission
            }else {
              db.collection('settings').doc('add-article-permission').set({ permission: true })
            }
        })

        // get general settings from datebase
        db.collection('settings').doc('general-settings')
        .onSnapshot(doc => {
            this.appName = doc.data().appName
        })

        this.initialize() // call a function for load data
    },
    methods: {
      // initialize data to data table
      initialize() {
        var i = 0 // data table increment value
        this.dataLoading = true // data table loading
        db.collection('contribute-requests').orderBy('time', 'desc').onSnapshot(snapshot => {
            this.dataLoading = false // data table loading
            snapshot.docChanges().forEach(change => {
              i++ // data table increment value
              let request = change.doc.data()
              request.serial = i // set data table increment value
              request.id = change.doc.id
              request.date = moment(change.doc.data().time).format('ll') // convert date
              request.currentUserId = request.userId

              // get how many articles
              db.collection('users').doc(request.userId).get()
              .then(snapshot => {
                request.userId = snapshot.data().name
                request.avatar = snapshot.data().avatar
                request.username = snapshot.data().username
              })

              if(change.type === 'added') {
                this.desserts.push(request) // push data
              }

              // when deleted data then removed real time by editedIndex
              if(change.type === "removed") {
                this.desserts = this.desserts.filter(item => {
                    return item.id != change.doc.id
                })
              }
            })
        })
      },
      // send email
      sendEmail(email) {
          window.open('mailto:' + email)
      },
      // user approval for start contributing
      approveRequest(item) {
            // update user contributing permission
            db.collection('users').doc(item.currentUserId).update({
                contributor: true
            }).then(() => {
                db.collection('contribute-requests').doc(item.id).delete()
                .then(() => {
                    // set notification
                    db.collection('notifications').add({
                        ownerId: item.currentUserId,
                        userId: this.$store.state.user.data.uid, // get uid form vuex
                        articleId: "",
                        categoryId: "",
                        time: Date.now(),
                        text: "Well done you're a contributor",
                        unseenAll: true
                    })
                })
            })
      },
      // get current request data and pass
      selectRequest(item) {
          this.requestDecline(item.id, item.currentUserId) // call a function and passinf data
      },
      // decline request for start contributing
      requestDecline(requestId, ownerId) {
            this.dialog = false
            db.collection('contribute-requests').doc(requestId).delete()
            .then(() => {
                // set notification
                db.collection('notifications').add({
                    ownerId: ownerId,
                    userId: this.$store.state.user.data.uid, // get uid form vuex
                    articleId: "",
                    categoryId: "",
                    time: Date.now(),
                    text: 'sorry! your request has been declined',
                    unseenAll: true
                })
            })
      }
    }  
}
</script>

<style scoped>
/*  data table styles */
.admin-users-list {
  width: 100%;
  padding-left: 30px;
}
.admin-users-list .v-avatar i {
  font-size: 16px;
}
.table-dark tr {
  background-color: #1E1E1E;
}
</style>